import { IconSearchStroked } from '@consta/icons/IconSearchStroked'
import { Select } from '@consta/uikit/Select'
import type { TextFieldPropValue } from '@consta/uikit/TextField'
import { TextField } from '@consta/uikit/TextField'
import {
  getWellsVspForProject,
  selectActiveProjectId,
  selectProjectFieldsAsSelectItems,
  useAppDispatch,
  useAppSelector,
} from '@core/core/store'
import type { FieldId, FilterType, SelectItem } from '@core/core/types'
import type { Nullable } from 'common/types'
import type { FC } from 'react'
import { useEffect, useState } from 'react'

import type { FilterForm, OnSetFilterFormFunc } from '../../types'
import { vspFilter } from './constants'
import css from './Filters.css'

type SpeedLawsFiltersProps = {
  initialForm: FilterForm
  onSetFilterForm?: OnSetFilterFormFunc
  forceWithVsp?: boolean
}

export const Filters: FC<SpeedLawsFiltersProps> = ({
  initialForm,
  onSetFilterForm,
  forceWithVsp = false,
}) => {
  const defaultFilter = vspFilter.find(
    ({ key }) => key === (forceWithVsp ? 'vsp' : initialForm.filter),
  )
  const fields = useAppSelector(selectProjectFieldsAsSelectItems)
  const initialField = fields.find(field => field.key === initialForm.fieldId)

  const projectId = useAppSelector(selectActiveProjectId)

  const [filter, setFilter] = useState(defaultFilter)
  const [searchQuery, setSearchQuery] = useState<Nullable<string>>(initialForm.searchQuery)
  const [field, setField] = useState(initialField ?? fields.at(0))

  const dispatch = useAppDispatch()

  useEffect(() => {
    const fieldId = field?.key ?? null
    const filterKey = filter?.key ?? 'all'
    onSetFilterForm?.({ fieldId, filter: filterKey, searchQuery })
  }, [searchQuery, field, filter])

  useEffect(() => {
    const fieldId = field?.key ?? ''
    if (projectId !== '' && fieldId !== '') {
      dispatch(getWellsVspForProject(projectId, fieldId))
    }
  }, [projectId, field])

  const onChangeValueSearch = (value: TextFieldPropValue) => {
    setSearchQuery(value)
  }

  const onChangeValueFieldsProject = (value: Nullable<SelectItem<FieldId>>) => {
    if (value) {
      setField(value)
    }
  }

  const onChangeValueShowingWells = (value: Nullable<SelectItem<FilterType>>) => {
    if (value) {
      setFilter(value)
    }
  }

  return (
    <div className={css.fieldsContainer}>
      <Select
        name="valueFieldsProject"
        size="xs"
        form="defaultClear"
        value={field}
        items={fields}
        className={css.selectField}
        getItemKey={item => item.key}
        onChange={onChangeValueFieldsProject}
      />
      <TextField
        size="xs"
        form={forceWithVsp ? 'brickDefault' : 'brick'}
        className={css.findText}
        placeholder="Найти скважины"
        value={searchQuery}
        withClearButton={true}
        leftSide={IconSearchStroked}
        onChange={onChangeValueSearch}
      />
      {!forceWithVsp && (
        <Select
          size="xs"
          form="clearDefault"
          items={vspFilter}
          value={filter}
          className={css.selectField}
          getItemKey={item => item.key}
          onChange={onChangeValueShowingWells}
        />
      )}
    </div>
  )
}
